'use client';

import { useFlags } from '@lib/flags/amplitude/client';
import { FLAG_TREATMENT, Flags } from '@lib/flags/flagConstants';
import c from 'classnames';
import { ReactNode } from 'react';

type ProductRowProps = {
  children: ReactNode;
  gridCols?: number;
};

export const ProductRow = ({ children, gridCols = 4 }: ProductRowProps) => {
  const { flags } = useFlags();
  const isNewSpacingEnabled =
    flags[Flags.UI_AND_MISSING_FILTERS]?.value === FLAG_TREATMENT;

  if (!children) {
    return null;
  }

  return (
    <div className="container relative">
      <div
        className={c(
          'hide-scrollbar flex gap-4 overflow-x-scroll md:grid md:overflow-visible',
          gridCols === 5 ? 'grid-cols-4 lg:grid-cols-5' : 'grid-cols-4',
          !isNewSpacingEnabled && 'lg:gap-5 lg:gap-y-2'
        )}
      >
        {children}
      </div>
    </div>
  );
};
